import './Footer.css';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-wrapper">
        <p>
          <a href='https://www.instagram.com/'>INSTAGRAM / </a>
          <a href='https://twitter.com/'>TWITTER /</a>
          <a href=''> NEWSLETTER /</a>
          <a href='https://www.youtube.com/'> YOUTUBE</a>
        </p>
      </div>
      <span className='made-by'>Made By Bartek Rosa @ 2022</span>
      
    </footer>
  )
}

export default Footer
